import classnames from 'classnames';
import React from 'react';
import Scroll from 'react-scroll';

import { DEFAULT_SCROLL_CONFIG } from '@constants/scroll';
import { OnClickEvent, OnClickHandler } from 'types/dom';

const clickHandler = (event: React.MouseEvent): void => {
  event.persist();

  const { id } = event.target as HTMLHeadingElement;

  if (id) {
    window.history.pushState('', '', `#${id}`);

    Scroll.scroller.scrollTo(id, {
      duration: DEFAULT_SCROLL_CONFIG.DURATION,
      smooth: DEFAULT_SCROLL_CONFIG.SMOOTH,
      offset: DEFAULT_SCROLL_CONFIG.OFFSET,
    });
  }
};

type DecoratedComponentProps = {
  onClick?: OnClickHandler;
  className?: string;
};

// TODO:: Will break propTypes of decorated components
// if used outside of MarkdownProcessor's `decorateComponents`
export const withAnchorHeading =
  (element: Function) =>
  ({ onClick, className, ...props }: DecoratedComponentProps): unknown =>
    element({
      ...props,
      onClick: (event: OnClickEvent) => {
        clickHandler(event);
        if (onClick) {
          return onClick(event);
        }
        return undefined;
      },
      className: classnames(className, 'heading-link'),
    });

export const addAnchorLinkToHeadings = {
  h1: withAnchorHeading,
  h2: withAnchorHeading,
  h3: withAnchorHeading,
};
